import type { FC } from 'react';
import { useEffect } from 'react';

import { SectionBrandmanager } from '../../components/section-brandmanager/section-brandmanager';
import { SectionCompaniesByIndustries } from '../../components/section-companies-by-industry/section-companies-by-industry';
import { SectionRecommendedCompanies } from '../../components/section-recommended-companies/section-recommended-companies';
import { useTrackPage } from '../../hooks/use-track-page';
import {
  pagesTrackingName,
  useNwtTrackingCompanies,
} from '../../utils/tracking';

import * as Styled from './logged-in-landing-page.styles';

export const LoggedInLandingPage: FC = () => {
  const trackNwtEvent = useNwtTrackingCompanies();

  useTrackPage({ pageName: pagesTrackingName.landing });

  useEffect(() => {
    trackNwtEvent({
      eventSchema: 'basic',
      page: 'companies/overview',
      event: 'viewed_screen',
    });
  }, [trackNwtEvent]);

  return (
    <Styled.Wrapper data-testid="LOGGED-IN-LANDING-PAGE">
      <SectionBrandmanager />
      <SectionRecommendedCompanies />
      <SectionCompaniesByIndustries />
    </Styled.Wrapper>
  );
};
